import { getDocs, getFirestore, doc, setDoc, QuerySnapshot, query, where, collection, getDoc, deleteDoc, updateDoc, DocumentSnapshot } from "firebase/firestore";
import { getApp } from 'firebase/app';
import { Injectable } from '@angular/core';
import { formatDate } from "@angular/common";
import { DocumentData } from "@angular/fire/compat/firestore";
import { Event } from "src/shared/models/event";
import { OrganizationService } from "./organization.service";

@Injectable({
  providedIn: 'root',
})
export class EventService {

  constructor(private orgService: OrganizationService) { }

  async getEvents(org?: string, interests?: string[]): Promise<Event[]> {
    const firestoreDB = getFirestore(getApp());
    let q = query(collection(firestoreDB, "events"));
    if (org) {
      q = query(q, where("organization", "==", org))
    }
    if (interests && interests.length > 0) {
      const orgQ = query(collection(firestoreDB, "Organizations"), where("interests", "array-contains-any", interests));
      const orgD = await getDocs(orgQ)
      let orgs:string[] = []
      orgD.forEach(d => orgs.push(d.id))
      q = query(q, where("organization", "in", orgs))
    }
    const documents = await getDocs(q);
    return this.docsToEvents(documents);
  }

  private docsToEvents(docs: QuerySnapshot<DocumentData>): Event[] {
    let events: Event[] = []
    docs.forEach(async document => {
      var doc = await this.docToEvent(document)
      if (doc) {
        events.push(doc)
      }
    });

    return events;
  }

  private async docToEvent(document: DocumentSnapshot<DocumentData>): Promise<Event> {
    return await this.dataToEvent(
      document.get("title"),
      document.get("description"),
      document.get("organization"),
      document.get("date"),
      document.get("image"),
      document.get("location"),
      document.get("time"),
      document.get("price")
    )
  }

  async dataToEvent(title: string, description: string, organization: string, date: number, image: string, location?: string, time?: string, price?: string): Promise<Event> {
    const firestoreDB = getFirestore(getApp());
    const orgCollection = doc(firestoreDB, "Organizations", organization);
    const docSnap = await getDoc(orgCollection)
    let event = {
      title: title,
      description: description,
      org: organization,
      orgName: docSnap.get("name"),
      date: "",
      image: image,
      location: location ?? "",
      time: time ?? "",
      price: price ?? "",
      interested: 0,
      tags: docSnap.get("interests")
    }

    event.date = formatDate(date, "longDate", "en-US");

    return event
  }

  async newEvent(title: string, description: string, organization: string, date: number, image: string, location?: string, time?: string, price?: string): Promise<Event> {
    const firestoreDB = getFirestore(getApp());
    const eventData = {
      title: title,
      description: description,
      organization: organization,
      date: date,
      image: image,
      location: location ?? null,
      time: time ?? null,
      price: price ?? null,
      interested: 1
    }

    const eventsCollection = doc(firestoreDB, "events", eventData.title);
    setDoc(eventsCollection, eventData)
      .then(eventData => {
        console.log("event added!");
      })
      .catch(error => {
        console.log(error);
        return null
      })
    const eventDocSnap = await getDoc(eventsCollection)
    return this.docToEvent(eventDocSnap)
  }

  async deleteEvent(title: string): Promise<boolean> {
    if (title) {
      const eventToDelete = doc(getFirestore(getApp()), "events", title);
      await deleteDoc(eventToDelete);
    } else {
      return false
    }
    return true
  }

  async updateEvent(event: Event): Promise<boolean> {
    if (event.title) {
      const eventThatsEdited = doc(getFirestore(getApp()), "events", event.title);
      await updateDoc(eventThatsEdited, {
        title: event.title,
        image: event.image,
        description: event.description,
        date: event.date
      });
    } else {
      return false
    }
    return true
  }

  async joinEvent(event: Event): Promise<number> {
    const eventInterested = doc(getFirestore(getApp()), "events", event.title);
    const intNum = event.interested + 1;
    await updateDoc(eventInterested, { interested: intNum });
    return intNum
  }


}